import { useEffect } from 'react';
import { useScrollToElement, isDevEnvironment } from '.';
import { isValidQuerySelector } from './isValidQuerySelector';
import { headerHeight } from './menuHeight';

export function useScrollToAnchorTag(location) {
  let { scrollTo } = useScrollToElement({ yOffset: headerHeight });
  useEffect(() => {
    if (!location?.hash) return;

    let hash = location?.hash.replace(/\?.*/, '') || '';
    let wasPushed = location?.action === 'PUSH'; // 👈  this only happens in client side navigation, thus don't animate on initial load

    let validSelector = isValidQuerySelector(hash);
    if (isDevEnvironment && !validSelector) console.error('got invalid selector pattern...', hash);

    if (!validSelector || !wasPushed) return;

    let targetElem = Boolean(hash) ? document.querySelector(hash) : undefined;
    if (targetElem) scrollTo(targetElem);
  }, [location, scrollTo]);
}
